module.exports = '/ng-templates/features/record-editation/field7-and-field8-editors/authority-field8-editor-modal/authority-field8-editor-modal.component.tpl.ftl';
